import { parseMolecularModelFromTexts } from "./ParseMolModelsUtils";
import { FileInfo } from "@/FileSystem/FileInfo";
import { convertFileInfosOpenBabel } from "@/FileSystem/OpenBabel/OpenBabel";
/**
 * Uses OpenBabel to parse the a molecular-model file.
 *
 * @param  {FileInfo}      fileInfo               The file to parse.
 * @param  {IFormatInfo}   formatInfo             The format of the file.
 * @param  {boolean}       [desalt]               Whether to desalt the
 *                                                molecules. Default is false.
 * @param  {IGen3DOptions} [gen3D]                Whether and how to generate 3D
 *                                                coordinates. Default is
 *                                                undefined.
 * @param  {boolean}       [surpressMsgs]         Whether to surpress messages.
 *                                                Default is false.
 * @param  {boolean}       [mergeBondedCompounds]  Whether covalently bonded
 *                                                compounds should be merged.
 *                                                Defaults to true.
 * @returns {Promise<TreeNodeList>}  A promise that resolves when the file is
 *    parsed. The promise resolves to an array of TreeNode objects, one for each
 *    frame. Can also resolve void.
 */
export function parseUsingOpenBabel(fileInfo, formatInfo, desalt = false, gen3D, surpressMsgs, mergeBondedCompounds = true) {
    // console.log("parseUsingOpenBabel called for:", fileInfo.name, "format:", formatInfo.primaryExt, "desalt:", desalt);
    const targetFormat = formatInfo.hasBondOrders ? "mol2" : "pdb";
    // Convert it to MOL2 format and load that using 3dmoljs.
    return convertFileInfosOpenBabel([fileInfo], targetFormat, gen3D, undefined, desalt, surpressMsgs)
        .then((contents) => {
        const hasMultipleFrames = contents.length > 1;
        const fileInfos = contents.map((c, i) => {
            // Separate basename and extension.
            // Need to account for multiple frames.
            let { name } = fileInfo;
            if (hasMultipleFrames) {
                // const prts = getFileNameParts(fileInfo.name);
                // name = `(frame ${i + 1}) ${prts.basename}.${prts.ext}`;
                name = `(frame${i + 1}) ${fileInfo.name}`;
            }
            return new FileInfo({
                contents: c,
                name: name,
            });
        });
        return parseMolecularModelFromTexts(fileInfos, targetFormat, mergeBondedCompounds);
    })
        .catch((err) => {
        // It's a catch block for the promise returned by
        // convertMolFormatOpenBabel.
        throw err;
    });
}
